import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { FormGroup, Box } from '@material-ui/core';
import { PasslyButton, PasslyTextField } from '@app/components';
import { IOffice365State } from '@app/components/SSOApps/addEditAppTabs';

interface IProps {
    setManagedConfig: Function;
    verifyCredentials: Function;
    officeConfig: IOffice365State;
    setState?: Function;
    isGraph?: boolean;
}

export const GraphApiConfig = ({ setManagedConfig, verifyCredentials, officeConfig, isGraph }: IProps) => {
    const { translation } = useTypedTranslation();
    const isButtonDisabled = isGraph
        ? officeConfig.managedSetup.graphApiClientIdGraphModule === '' ||
          officeConfig.managedSetup.graphApiTenantIdGraphModule === '' ||
          officeConfig.managedSetup.domainGraphModule === ''
        : officeConfig.managedSetup.graphApiClientId === '' ||
          officeConfig.managedSetup.graphApiTenantId === '' ||
          officeConfig.managedSetup.domain === '';

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let transformedName = name;

        if (isGraph) {
            transformedName = `${name}GraphModule`;
        }

        setManagedConfig(transformedName, value, isGraph);
    };

    return (
        <>
            <FormGroup>
                {isGraph ? (
                    <div className='form__row'>
                        <PasslyTextField
                            id='msolDomain-input'
                            label={'MSOL_DOMAIN'}
                            name='domain'
                            value={isGraph ? officeConfig.managedSetup.domainGraphModule : officeConfig.managedSetup.domain}
                            onChange={handleInputChange}
                            fullWidth
                        />
                    </div>
                ) : null}
                <div className='form__row'>
                    <PasslyTextField
                        id='clientId-input'
                        label={'MSOL_APP_ID'}
                        name='graphApiClientId'
                        value={isGraph ? officeConfig.managedSetup.graphApiClientIdGraphModule : officeConfig.managedSetup.graphApiClientId}
                        onChange={handleInputChange}
                        fullWidth
                    />
                </div>
                <div className='form__row'>
                    <PasslyTextField
                        id='username-input'
                        label={'MSOL_DIRECTORY_ID'}
                        name='graphApiTenantId'
                        type='email'
                        value={isGraph ? officeConfig.managedSetup.graphApiTenantIdGraphModule : officeConfig.managedSetup.graphApiTenantId}
                        onChange={handleInputChange}
                        fullWidth
                    />
                </div>
            </FormGroup>
            <Box mt={4}>
                <PasslyButton id='verify' variant='contained' color='primary' onClick={verifyCredentials} disabled={isButtonDisabled}>
                    {translation('FEDERATION_VERIFY')}
                </PasslyButton>
            </Box>
        </>
    );
};
